export default __webpack_public_path__ + "static/media/vinyl_teal.97f1b041.svg";